// Attach initMap to the window object so that the google maps api link callback can access it.
window.initMap = () => {
	let mapRoot = document.querySelector('.map #map-root');
	let cords = {
		lat: parseFloat(window.dc_map_cords.lat),
		lng: parseFloat(window.dc_map_cords.lng)
	};
	let map = new google.maps.Map(mapRoot, {
		center: cords,
		zoom: 16,
		scrollwheel: false,
		navigationControl: false,
		mapTypeControl: false,
		scaleControl: false,
		draggable: false,
		gmapTypeId: google.maps.MapTypeId.ROADMAP
	});
	new google.maps.Marker({
		position: cords,
		map: map,
		title: 'NEK Hovedkontor'
	});
}
